var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('header-component',{attrs:{"title":"Privacy Policy"}}),_c('privacy-policy-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }